import axios from "axios";
import { baseURL } from "../redux/network/constant";

const publicClient = axios.create({
  baseURL,
  withCredentials: true,
});

export default publicClient;
